export default __webpack_public_path__ + "assets/auto-renew.cf70160e.svg";